<template>
  <div>
    <customer-identity-change-audit-list />
  </div>
</template>

<script>
import CustomerIdentityChangeAuditList from './list.vue'

export default {
  components: {
    CustomerIdentityChangeAuditList
  }
}
</script>

